/**
 * Dependencies
 */
import http from '../../../../../services/HttpService'

const getDataType = type => {
    if (type === 'summary') {
        return 'summary'
    } else if (type === 'proForma') {
        return 't12-vs-proforma'
    } else if (type === 'schedule') {
        return 'schedule'
    } else {
        return 'summary'
    }
}

/**
 * Fetch the other income data
 *
 * @param  {Object} options.commit
 * @param  {String} type
 * @return {void}
 */
const getData = ({ commit, rootState }, obj) => {
    let url = `projects/${rootState.route.params.projectId}/misc-inc/?scope=${getDataType(obj.type)}`
    if (obj.timesample) {
        url += `&time_sample=${obj.timesample}`
    }
    commit('SET_LOADING')
    http.get(url)
        .then(res => {
            commit('SET_DATA', {
                type: obj.type,
                data: res.data.data.miscinc,
                meta: res.data.meta
            })
            commit('RESET_LOADING')
        })
        .catch(() => {
            commit('RESET_LOADING')
        })
}

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {void}
 */
const resetState = ({ commit }) => commit('RESET_STATE')

export default {
    getData,
    resetState
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/other-income/actions.js